import {
  GetCounterProposalResponse,
  useGetCounterProposalQuery,
} from '@/apis/extended/negotiation';

export const useNegotiationClauses = (contractId: string) => {
  const { data } = useGetCounterProposalQuery(contractId ?? '', {
    skip: !contractId,
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    pollingInterval: 0,
  });
  const negotiation = (data as GetCounterProposalResponse)?.negotiation;
  if (!negotiation) return [];

  const contractClauses: {
    title: string;
    description: string;
    status: string;
  }[] = [];

  const hasValue = (value: any): boolean => {
    return value != null && value !== '' && value !== undefined;
  };

  if (hasValue(negotiation.offeredPrice)) {
    contractClauses.push({
      title: 'Offered Price',
      description: `${negotiation.offeredPrice.value}`,
      status: negotiation.offeredPrice.status,
    });
  }

  if (hasValue(negotiation.EarnestMoney)) {
    contractClauses.push({
      title: 'Earnest Money Deposit',
      description: `${negotiation.EarnestMoney.value}`,
      status: negotiation.EarnestMoney.status,
    });
  }

  if (hasValue(negotiation.ClosingDate)) {
    contractClauses.push({
      title: 'Closing Date',
      description: `${negotiation.ClosingDate.value}`,
      status: negotiation.ClosingDate.status,
    });
  }

  if (hasValue(negotiation.AppraisalContingency)) {
    contractClauses.push({
      title: 'Appraisal Contingency',
      description: `${negotiation.AppraisalContingency.value}`,
      status: negotiation.AppraisalContingency.status,
    });
  }

  if (hasValue(negotiation.HomeInspection)) {
    contractClauses.push({
      title: 'Home Inspection Contingency',
      description: `${negotiation.HomeInspection.value}`,
      status: negotiation.HomeInspection.status,
    });
  }

  if (hasValue(negotiation.FinancingContingency)) {
    contractClauses.push({
      title: 'Financing Contingency',
      description: `${negotiation.FinancingContingency.value}`,
      status: negotiation.FinancingContingency.status,
    });
  }

  if (hasValue(negotiation.postCloseOccupancy)) {
    contractClauses.push({
      title: 'Post Close Occupancy',
      description: `${negotiation.postCloseOccupancy.value}`,
      status: negotiation.postCloseOccupancy.status,
    });
  }

  if (hasValue(negotiation.Suggested)) {
    contractClauses.push({
      title: 'Suggested',
      description: `${negotiation.Suggested.value}`,
      status: negotiation.Suggested.status,
    });
  }

  if (hasValue(negotiation.Contingent)) {
    contractClauses.push({
      title: 'Contingent',
      description: `${negotiation.Contingent.value}`,
      status: negotiation.Contingent.status,
    });
  }

  return contractClauses;
};
